
<template lang="pug">
  .product-carousel
    icon-button.product-carousel__prev(
      v-if="multipleImages && 'mobile' !== $mq"
      label="Next Slide",
      icon="chevron-left-big",
      size="64px"
      @click="$refs.productImageCarousel.slidePrev()"
    )
    icon-button.product-carousel__next(
      v-if="multipleImages && 'mobile' !== $mq"
      label="Previous Slide",
      icon="chevron-right-big",
      size="64px"
      @click="$refs.productImageCarousel.slideNext()"
    )
    carousel(
      ref="productImageCarousel",
      v-if="product.images",
      :slides-to-show="1",
      :infinite="true",
      :dots="true",
      :thumbnail-images="!['mobile', 'tablet'].includes($mq) ? thumbnailImages : []"
    )
      slide(v-for="(image, index) in images", :key="index")
        product-carousel-image(:image="image")
</template>

<script>
  import { mapState } from 'vuex';
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import ProductCarouselImage from 'scripts/components/product/ProductCarouselImage.vue';

  export default {
    name: 'ProductCarousel',
    components: {
      IconButton,
      Carousel,
      Slide,
      ProductCarouselImage,
    },
    props: {
      product: Object,
    },
    computed: {
      ...mapState({
        currentVariantId: state => state.productPage.currentVariantId,
      }),
      images () {
        return (this.product && this.product.images) ? this.product.images : [];
      },
      thumbnailImages () {
        return this.images.map(image => {
          // Handle both string URLs (from .js API) and objects (from JSON)
          if (typeof image === 'string') {
            // If image is a string URL, create an object with src
            return {
              src: image
            };
          } else if (image && typeof image === 'object') {
            // If image is an object, ensure it has a src property
            return {
              ...image,
              src: image.src || image.url || ''
            };
          } else {
            // Fallback for unexpected types
            return {
              src: ''
            };
          }
        });
      },
      multipleImages () {
        return this.images.length > 1;
      },
    },
  };
</script>

<style scoped lang="scss">
  .product-carousel {
    position: relative;
    padding: 0 #{24px + $grid-gutter * 2};

    @include mobile-only {
      padding: 0 #{$grid-gutter * 1.5};
      max-width: 550px;
      margin-left: auto;
      margin-right: auto;
    }

    &__next,
    &__prev {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
    }

    &__next {
      right: 45px;

      @include mobile-only {
        right: 4px;
      }
    }

    &__prev {
      left: 45px;

      @include mobile-only {
        left: 4px;
      }
    }

    &__image {
      align-self: center;
    }

    &::v-deep {
      .carousel__dots {
        margin-top: $grid-gutter;
      }
    }
  }
</style>
